'use client'
import React, { useState } from 'react'
import { Box, cn, css } from '@hanzo/ui'
import { ArrowRight, Plus } from 'lucide-react'
import { Button, Card } from '@hanzo/ui/primitives'
import { Logo } from '..'

interface MobileNavMenuAIProps {
    setMenuOpen: (open: boolean) => void
}

const MobileNavMenuAI: React.FC<MobileNavMenuAIProps> = ({ setMenuOpen }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    return (
        <>
            <Box className="w-full  text-2xl cursor-pointer">
                <Box className='flex justify-between'>
                    <Logo variant='wordmark' size='md' outerClx={'p-6 h-full'} />
                    <Box tag="span" className={cn('grid', 'block h-full aspect-square hover:bg-background sm:hover:bg-level-1 active:scale-75 text-foreground will-change-transform transition-transform transition-scale transition-duration-[1500] mt-6 mr-6 ' +
                        (!open ? 'rotate-none' : 'rotate-135 scale-110'))}>
                      <Plus width={28} height={28} style={css('w-full h-full')} onClick={() => setMenuOpen(false)} />
                    </Box>
                </Box>
                <Box className="flex items-center gap-5 border-b border-[#3A3A3A] mt-4 rounded-full bg-muted-4 mx-6">
                    <Box className="text-muted-1 font-bold flex-1 flex justify-between min-h-12 items-center px-2" onClick={() => setIsOpen(true)}>
                        <Box tag="span" className='text-base pl-2 font-light'>Ask AI a question</Box>
                        <ArrowRight />
                    </Box>
                </Box>
            </Box>
            <Box className={
                'fixed bottom-0 sm:bottom-16 right-0 w-full h-full ' +
                'sm:max-w-[400px] sm:max-h-[550px] sm:px-4 z-floating ' +
                (isOpen ? 'flex' : 'hidden')
            }>
                <Card className='flex flex-col h-full w-full'>
                    <Box className='flex px-4 py-2 h-16 bg-level-0 items-center justify-between'>
                        <Box tag="h3" className='font-semibold font-heading'>LUX<Box tag="span" className='opacity-60'>AI</Box></Box>
                        <Button onClick={() => setIsOpen(false)} variant='link' size='icon' className='w-fit sm:hidden'>
                            <Plus className='w-6 h-6 flex-none mr-1 rotate-45 transition-transform' />
                        </Button>
                    </Box>
                    <iframe src="https://lux.chat/iframe" className='h-full' />
                </Card>
            </Box>

        </>
    )
};

export default MobileNavMenuAI;